<template>
  <div class="industry-report" :style="{ height: list && list.length ? 'auto' : '100%' }">
    <div class="search-box-page">
      <div class="search-item">
        <div class="search-content">
          <el-input class="input-v2 input-round" v-model="queryParams.key" :placeholder="$t('reportsName')" suffix-icon="el-icon-search" clearable @change="handleSearch" />
        </div>
      </div>
    </div>
    <div class="data-list" v-if="list && list.length">
      <el-card :body-style="{ padding: '0px' }" v-for="item in list" :key="item" class="data-item pointer" @click.native="handleView(item)">
        <el-image style="width: 100%; height: 300px" :src="item.reportCoverPath" fit="cover"></el-image>
        <div class="data-bottom p10 flex vertical acenter">
          <div class="font-13 name">{{ item.reportName }}</div>
          <div class="font-12 flex jbetween acenter time">
            <span class="date">{{ item.createTime }}</span>
            <span>
              <i class="el-icon-view"></i>
              <span class="pl5">{{ item.readTimes || 0 }}</span>
            </span>
          </div>
        </div>
      </el-card>
    </div>
    <div style="height: calc(100% - 80px);" v-else>
      <bsp-empty style="height: 100%;"></bsp-empty>
    </div>
  </div>
</template>

<script>
  import * as api from '@/api/policy/policyLibrary';
  export default {
    name: "IndustryReport",
    data() {
      return {
        loading: true,
        queryParams:{
          key: ''
        },
        list: []
      }
    },
    created() {
      this.getData();
    },
    methods: {
      // 查看详情
      handleView(val) {
        let routeUrl = this.$router.resolve({
          path: '/policy/policyLibrary/industryReportView',
          query: {
            id: val.id
          }
        });
        window.open(routeUrl.href, "_blank");
      },
      // 搜索
      handleSearch(val) {
        this.getData();
      },
      // 获取列表
      getData() {
        this.loading = true;
        let params = {
          ...this.queryParams
        }
        api.reportFuzzy(params)
          .then(res => {
            this.loading = false;
            this.list = res.data.data;
          })
          .catch(error => {
            this.loading = false;
          })
      }
    }
  }
</script>
